import React from 'react';
import bgImage from '../../assets/servicesImages/csds/hero.png';
import bgImage2 from '../../assets/servicesImages/csds/hero2.png';
import Slider from 'react-slick';
import icona from '../../assets/servicesImages/csds/a.png';
import iconb from '../../assets/servicesImages/csds/b.png';
import iconc from '../../assets/servicesImages/csds/c.png';
import icond from '../../assets/servicesImages/csds/d.png';
import icone from '../../assets/servicesImages/csds/e.png';
import iconf from '../../assets/servicesImages/csds/f.png';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const items = [
    {
        icon: icona,
        title: 'Application Development',
        desc: 'We understand that every business has a different software requirement and we cater them with a great variety of Software Development Services.'
    },
    {
        icon: iconb,
        title: 'Product Development & Maintenance',
        desc: "Developing tailor-made products that are beyond expectations is our forte. We tailor software products to meet business needs including end-user demand."
    },
    {
        icon: iconc,
        title: 'Dedicated Development Center',
        desc: "Sparse School/College ERP modules are adaptable and customizable to your institution's specific needs, making it a dynamic solution."
    },
    {
        icon: icond,
        title: 'Migration & Upgradation',
        desc: "Our tech engineers assist you in moving software to different platforms or upgrading to new versions."
    },
    {
        icon: icone,
        title: 'Testing and QA',
        desc: "Our QA & Testing service helps exceed end-user expectations by improving quality with less effort."
    },
    {
        icon: iconf,
        title: 'Enterprise Solutions',
        desc: 'We turn your concept into reality with expert support throughout the software development lifecycle.'
    }
];

const settings = {
    className: "center",
    centerMode: true,
    infinite: true,
    speed: 500,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
        {
            breakpoint: 3000, // large screens default
            settings: {
                slidesToShow: 4,
            },
        },
        {
            breakpoint: 1024, // md to lg
            settings: {
                slidesToShow: 2.5,
                centerMode: false,
            },
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                centerMode: false,
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                centerMode: false,
            }
        }
    ]
};

const CSDS = () => {
    return (
        <div className='flex flex-col gap-16'>

            {/* Hero Section */}
            <div className='h-[40vh] md:h-[50vh] lg:h-screen w-full text-white flex justify-start items-center pt-24 relative bg-cover bg-center'
                style={{ backgroundImage: `url(${bgImage})` }}>
                <div className="absolute inset-0 bg-[rgba(89, 119, 221, 0.15)] z-0"></div>
                <div className='flex flex-col gap-12 p-6 md:p-12 lg:p-28 z-10'>
                    <div className='max-w-full md:max-w-[600px] h-auto gap-8'>
                        <p className='font-nunito text-[20px]  md:text-[40px] font-bold leading-tight text-left'>
                            CUSTOM SOFTWARE DEVELOPMENT SERVICES
                        </p>
                        <p className="text-[16px]  md:text-[20px] max-w-full md:max-w-[550px] leading-relaxed text-left">
                            Our specialty is custom software product creation, and we've completed a vast range of projects with clients all over the world.
                        </p>
                    </div>
                </div>
            </div>

            {/* About Section */}
            <div className='flex flex-col gap-9 px-6 sm:px-10 lg:px-32'>
                <p className='text-center font-nunito text-2xl sm:text-3xl font-semibold'>About CUSTOM SOFTWARE DEVELOPMENT SERVICES</p>
                <p className='font-nunito text-sm sm:text-base leading-relaxed text-justify'>
                    Due to our extensive expertise, team of trained experts, and core industry knowledge, we are a leading custom software development firm. We recognise that every business has unique software specifications, and we provide a wide range of software development services to meet those needs.
                </p>
            </div>

            {/* Why Us Section */}
            <div className='flex flex-col gap-9 px-6 sm:px-10 lg:px-32'>
                <p className='text-center font-nunito text-2xl sm:text-3xl font-semibold'>Why Us?</p>
                <img src={bgImage2} alt='Why Us' className='w-full h-auto object-cover rounded-lg' />
            </div>

            {/* Services We Provide */}
            <div className='flex flex-col gap-9 px-6 sm:px-10 lg:px-48'>
                <p className='text-center font-nunito text-2xl sm:text-3xl font-semibold'>We Provide</p>
                <p className='font-nunito text-sm sm:text-base text-center leading-relaxed'>
                    We recognise that every company has unique software requirements, and we provide a wide range of CUSTOM SOFTWARE DEVELOPMENT SERVICES to meet those needs.
                </p>
            </div>

            {/* Slider Section */}
            <div className='px-6 md:px-10 mb-20'>
    <Slider {...settings}>
        {items.map((item, index) => (
            <div key={index} className='p-4 group'>
                <div className='bg-white border shadow-xl hover:shadow-2xl transition-shadow duration-300 rounded-lg p-6 h-[340px] flex flex-col items-center text-center hover:scale-[1.03] hover:text-blue-800'>
                    <img src={item.icon} alt='icon' className='w-[60px] h-[60px] mb-4' />
                    <h4 className='font-bold text-lg mb-2'>{item.title}</h4>
                    <p className='text-sm text-gray-600'>{item.desc}</p>
                </div>
            </div>
        ))}
    </Slider>
</div>



        </div>
    );
};

export default CSDS;
